<template>
    <v-card tile class="pb-10">
        <div class="bg-banner d-flex">
            <v-container fluid style="width:90%" class="d-flex align-center">
                <div class="section-title-wrap section-title-wrap--left ">
                    <!-- heading -->
                    <div class="section-title-inner d-flex">
                        <h2>
                            {{$t('LandingHeadText')}}
                        </h2>
                    </div>
                </div>
                <div class="hero-img d-none d-md-block">

                </div> 
            </v-container> 
        </div>
    
        <v-card-text class="mt-10 px-0">
            <v-container fluid style="width:90%">
                <v-row>
                    <v-col cols="12" class="d-flex justify-space-between">
                        <div>
                            <h2 class="section-title">{{$t('ParticipateInSrveys')}}</h2>
                            <p class="mt-6 d-sm-block d-none">{{$t('SubscribeToNewSurveys')}}</p>
                        </div>
                       
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <router-link class="mx-3 text-decoration-none" :to="{ name: 'available-Surveys'}" custom>
                                    <v-btn elevation="0" outlined large dense class="ms-0" v-bind="attrs" v-on="on" style="border-color:#D2D6DB; font-size: 16px; font-weight: 700;">{{ $t('VoteNow') }} </v-btn>
                                </router-link>
                            </template>
                            <span>{{$t('VoteNow')}}</span>
                        </v-tooltip>
                    </v-col>
                    <p class="d-sm-none d-block ps-4">{{$t('SubscribeToNewSurveys')}}</p>
                   <v-card elevation="0" width="100%">
                        <v-row class="d-flex justify-md-center justify-start align-md-center mb-12 pb-12 mt-10">
                            <v-col cols="6" md="3" class="mb-6 mb-sm-0">
                                <v-card class="mx-auto elevation-0 pa-4 d-flex flex-column align-center justify-center" height="170">
                                    <div class="rounded-circle d-flex justify-center mb-6" style="background-color: #F3FCF6; height: 70px; width: 70px;">
                                        <v-icon x-large class="my-4" color="#067647">mdi-vote-outline</v-icon>
                                    </div>
                                            <div class="text-center mt-2 primary--text" style="font-size:48px; font-family: IBMPlexSansArabic-Regular;  color: #14573A!important">
                                                {{ resultsStatics.surveyVote}}
                                            </div>
                                            <div class="text-center pt-4 mt-2">
                                                <p class="mt-4" style="font-family:'IBMPlexSansArabic-regular'"> {{$t('SurveyAvailableForVoting')}} </p>
                                            </div>
                                </v-card>
                            </v-col>
                            <v-col cols="6" md="3" class="mb-6 mb-sm-0">
                                <v-card class="mx-auto elevation-0 pa-4 d-flex flex-column align-center justify-center" height="170">
                                    <div class="rounded-circle d-flex justify-center mb-6" style="background-color: #F3FCF6; height: 70px; width: 70px;">
                                        <v-icon x-large class="my-4" color="#067647">mdi-forum</v-icon>
                                    </div>

                                    <div class="text-center mt-2 primary--text" style="font-size:48px; font-family: IBMPlexSansArabic-Regular;  color: #14573A!important">
                                                {{ resultsStatics.surveyOld}}
                                    </div>
                                    <div class="text-center pt-4 mt-2">
                                        <p class="mt-4" style="font-family:'IBMPlexSansArabic-regular'"> {{$t('PreviousSurvey')}} </p>
                                    </div> 
                                </v-card>              
                            </v-col>
                            <v-col cols="6" md="3" class="mb-6 mb-sm-0">
                                <v-card class="mx-auto elevation-0 pa-4 d-flex flex-column align-center justify-center" height="170">
                                    <div class="rounded-circle d-flex justify-center mb-6" style="background-color: #F3FCF6; height: 70px; width: 70px;">
                                        <!--<v-icon x-large class="my-4" color="#067647">mdi-share</v-icon>-->
                                        <img class="my-4" src="/share.svg" style="width:50%"/>
                                    </div>
                                    
                                    <div class="text-center mt-2 primary--text" style="font-size:48px; font-family: IBMPlexSansArabic-Regular; color: #14573A!important">
                                                {{  resultsStatics.surveysPatCount }}
                                                <!--<v-icon size="85" color="primary">mdi-cog-sync-outline</v-icon>-->
                                            </div>
                                            <div class="text-center pt-4 mt-2">
                                                <p class="mt-4" style="font-family:'IBMPlexSansArabic-regular'">{{$t('SurveysParticipantsCount')}} </p></div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>  
                </v-row>
            </v-container>
            <div class="greyBg pb-15 relative">
                <v-row>
                    <v-col md="12" sm="12" xs="12">
                        <v-card color="transparent" tile :loading="loading" class="elevation-0 pa-0 pt-10">
                            <v-container fluid style="width:90%">
                                <h2 class="section-title">{{ $t('AvailableSurveys') }}</h2>

                           
                            
                                <p class="mt-6" v-if="results.length == 0" >{{$t('NoSurveysAvailable')}}</p>
                           </v-container>
                            <v-card-text class="mb-10">
                            
                                    <v-sheet class="mx-auto " elevation="0" color="transparent">
                                        <v-slide-group
                                        v-model="model"
                                        class="py-0"
                                        active-class="success"
                                        show-arrows
                                        >
                                        <v-slide-item
                                            v-for="(survey, index) in results"
                                            :key="index"
                                           
                                        >
                                   
                                        <v-card class="elevation-0 ma-3 rounded-xl d-flex flex-column justify-space-between" outlined min-height="200" width="350px">
                                            <div class="rounded-circle d-flex justify-center mx-4 my-4" style="background-color: #F3FCF6; height: 70px; width: 70px;">
                                                    <v-icon x-large color="#067647">mdi-vote-outline</v-icon>
                                                </div>
                                            <v-card-title class="cardtitle" style="width:unset; background-color:transparent"> {{ survey.name.length > 35 ? survey.name.substring(0, 35) + '...' :  survey.name }}
                                            <p class="black--text" style="font-size: 16px;">
                                              
                                                    {{ survey.description.length > 150 ? survey.description.substring(0, 150) + '...' :  survey.description }}
                                             
                                            </p>
                                        </v-card-title>
                                            <v-card-actions class="py-5">
                                               
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <router-link style="background: #1B8354; " v-if="!survey.voted" class="mx-3 pa-3 px-5 rounded-lg text-decoration-none" :to="{ name: 'public-survey-form', query: { id: survey.id,fromLanding:true, participantId:survey.participantId }}" custom>
                                                            <span class="action-btn" v-bind="attrs" v-on="on">{{ survey.participantId?$t('ContinueSurvey'):$t('StartSurvey')}}</span>
                                                        </router-link>
                                                        <v-chip v-else class="ms-2" color="error">{{ $t('Voted') }}</v-chip>
                                                    </template>

                                                    <span> {{ $t('Vote') }}</span>
                                                </v-tooltip>
                                            </v-card-actions>
                                        </v-card>
                                   
                                </v-slide-item>
                                </v-slide-group>
                                </v-sheet>
                              

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
      
        </div>
            <v-container class="pt-10" fluid style="width:90%">

        
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card class="rounded-xl px-4 py-4" elevation="0" outlined>
                            <Area :key="chartKeySurvey" :height="300" width="100%" :series="seriesSurvey"  :yearTitlePrefix="$t('SurveyInYear')" :language="CompLang" :yearcount="YearCountSurvey" />
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card class="rounded-xl px-4 py-4" elevation="0" outlined>
                            <Area :key="chartKeySurveyVote" :height="300" :series="seriesSurveyVoted" :yearTitlePrefix="$t('SurveyVoteInYear')" :language="CompLang"  :yearcount="YearCountSurveyVote" />
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Area from '@/components/app/charts/Area.vue'
    import SurveyService from '@/services/SurveyService.js'
    import Cookies from 'js-cookie'
    import SettingsService from '@/services/SettingsService'
    export default {
        components: {
            Area
        },

        data() {
            return {
                model:null,
                results: [],
                CompLang: '',
                resultsStatics: {
                    surveyVote: 0,
                    surveyOld: 0,
                    surveysPatCount: 0,
                    dataChart: {
                        name: '',
                        data: [],
                    },
                    votedChart: {
                        name: '',
                        data: [],
                    },
                },
                seriesSurvey: [{
                    name: '',
                    data: new Array(12).fill(0)
                }],
                seriesSurveyVoted: [{
                    name: '',
                    data: new Array(12).fill(0)
                }],
                loading: false,
                CountSurvey:'',
                CountSurveyVote: '',
               YearCountSurvey: '',
                YearCountSurveyVote: '',
                chartKeySurvey: 0,
                chartKeySurveyVote: 0,
            }
        },

        created() {

            this.listStatisticsHome()
            this.listHomePageSurveys()


        },
        computed: {
            ...mapGetters('user', ['language']),

            getLanguage() {
                return this.language == null ? 'ar' : this.language

            }
        },
        methods: {
            async listHomePageSurveys() {
                this.loading = true
                var language = this.getLanguage
                this.CompLang = language
                var votescount = await SettingsService.getSurveyAttendancePerUser()
                SurveyService.listHomePageSurveys(language).then((res) => {
                    this.results = res.data
                    var voted = Cookies.get('surveysVoted')
                    var answers = Cookies.get('savedSurveyAnswers')
                    var savedSurveyAnswers = []
                    var surveysVoted = []
                    if (voted) {
                        surveysVoted = JSON.parse(voted)
                    }
                    if (answers) {
                        savedSurveyAnswers = JSON.parse(answers)
                    }
                    this.results.map(survey => {
                        var votedfound = surveysVoted.filter(x => x.surveyId == survey.id)
                        if (votedfound.length > 0) {
                            survey.voted = votedfound[0].count >= votescount.data
                        }
                        var found = savedSurveyAnswers.filter(x => x.surveyId == survey.id)
                        if (found.length > 0) {
                            survey.participantId = found[0].participantId
                        }
                    })
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            listStatisticsHome() {
                this.loading = true
                SurveyService.listStatisticsHome().then((res) => {
                    const stats = res && res.data ? res.data.data || res.data : {}
                    this.resultsStatics = {
                        ...this.resultsStatics,
                        ...stats,
                    }
                    const currentDate = new Date()
                    const monthNb = currentDate.getMonth() + 1

                    const dataChart = this.resultsStatics.dataChart || { data: [], name: '' }
                    const votedChart = this.resultsStatics.votedChart || { data: [], name: '' }

                    const resultSurvey = dataChart.data.find(innerArray => innerArray[0] === monthNb)
                    this.CountSurvey = resultSurvey ? resultSurvey[1] : null
                    this.YearCountSurvey = resultSurvey ? resultSurvey[2] : null
                    const surveySeries = [{
                        name: dataChart.name,
                        data: this.formatChartData(dataChart.data)
                    }]
                    this.seriesSurvey = surveySeries
                    this.chartKeySurvey += 1

                    const resultSurveyVote = votedChart.data.find(innerArray => innerArray[0] === monthNb)
                    this.CountSurveyVote = resultSurveyVote ? resultSurveyVote[1] : null
                    this.YearCountSurveyVote = resultSurveyVote ? resultSurveyVote[2] : null

                    const surveyVotedSeries = [{
                        name: votedChart.name,
                        data: this.formatChartData(votedChart.data)
                    }]
                    this.seriesSurveyVoted = surveyVotedSeries
                    this.chartKeySurveyVote += 1

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            formatChartData(rawData = []) {
                const monthlyData = new Array(12).fill(0)
                rawData.forEach(item => {
                    if (!Array.isArray(item) || item.length < 2) {
                        return
                    }
                    const [month, value] = item
                    const index = Number(month) - 1
                    if (index >= 0 && index < 12) {
                        monthlyData[index] = Number(value) || 0
                    }
                })
                console.debug('formatted chart data', monthlyData)
                return monthlyData
            },
        },
    }
</script>
<style>
h3 {
    font-size: 30px;
    font-family: IBMPlexSansArabic-SemiBold;
}
body {
    font-family: IBMPlexSansArabic-regular;
    font-size: 16px;
}
p{
    font-size: 16px;
    color: #000;
    font-family: IBMPlexSansArabic-regular;
}
    .bg-banner {
        height: 500px;
         position:relative ;
         background-color: #F5F7F7;
        }
        .hero-img {
            background-image: url(../assets/images/hero-img.svg);
            position: absolute;
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;

        }

        .section-title-wrap h2 {
            font-size: 60px;
            font-weight:800;
            font-family: IBMPlexSansArabic-SemiBold;

        }
        .section-title {
            font-size: 30px;
            font-family: IBMPlexSansArabic-SemiBold;
            color: #000;
        }
        .greyBg {
            background-color: #F9FAFB;
        }
        .action-btn {
            color: white;
            font-size: 16px;
            font-family: IBMPlexSansArabic-Regular;
            text-align: center;
        }
        .cardtitle {
            font-size: 18px;
            font-family: IBMPlexSansArabic-Bold;
        }
        .v-slide-group__next, .v-slide-group__prev {
            position: absolute;
            bottom: -80px;
            width: 50px;
            height: 50px;
        }
        .v-slide-group__prev:not(.v-slide-group__prev--disabled), .v-slide-group__next:not(.v-slide-group__next--disabled) {
            background-color: #1b8354;
            
            border-radius: 50%;
        }
        .v-slide-group__prev {
            right: 78px;
        }
        .v-slide-group__next{
            right: 140px;
        }
        .v-slide-group__next.v-slide-group__next--disabled i, .v-slide-group__prev.v-slide-group__prev--disabled i  {
color: black;
        }
        .v-slide-group__next i, .v-slide-group__prev i {
            color: #fff!important;
            font-size: 30px!important;
        }
        .v-slide-group__prev .v-icon.v-icon, .v-slide-group__next .v-icon.v-icon {
            font-size: 30px;
        }
        .relative {
            position: relative;
        }
        .v-application--is-ltr.theme--light .hero-img {
            right: 0;
            left: auto;
        }
        .v-application--is-ltr.theme--light .v-slide-group__prev {
            right: 140px;
        }
        .v-application--is-ltr.theme--light .v-slide-group__next{
            right: 78px;
        }
        @media only screen and (max-width: 600px) { 
            .bg-banner {
                height: 300px;
            }
            .v-slide-group__prev {
                right: 20px;
            }
            .v-slide-group__next{
            right: 80px;
        }
        }
</style>